import React from "react"

type Props = {
  href: string
  children: React.ReactNode
  onPress?: () => void
}

const ExternalLink = ({ href, children, onPress }: Props): React.ReactElement => {
  return (
    <a href={href} target="_blank" rel="noreferrer" onClick={onPress}>
      {children}
    </a>
  )
}

export default ExternalLink